import { createContext } from 'react';

const SessionContext = createContext<{
  csrfTokenName?: string;
  csrfTokenValue?: string;
}>({});

export default SessionContext;
